const endpoints = {
	getConversations: '/conversations/getConversations',
	getConversation: '/conversations/getConversation',
	getArchivedConversations: '/conversations/getArchivedConversations',
	newMessage: '/conversations/newMessage',
	editConversationUser: '/conversations/editConversationUser',
	sendScheduleEmail: '/schedule/sendScheduleEmail',
	confirmUserSchedule: '/schedules/confirmUserSchedule'
}
export {endpoints}